/**
 * Страница профиля тренера
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@shared/store/authStore';

export default function ProfilePage() {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const trainer = user;

  const handleLogout = () => {
    logout();
    navigate('/'); // Редирект на главную страницу
  };

  return (
    <div className="space-y-4 sm:space-y-6">
        {/* Основная информация */}
        <div className="bg-slate-800/40 backdrop-blur-xl rounded-xl sm:rounded-2xl shadow-lg overflow-hidden border border-slate-700/50">
          <div className="bg-gradient-to-r from-amber-500/20 to-amber-600/20 backdrop-blur-xl p-4 sm:p-6 text-white border-b border-amber-500/20">
            <div className="flex items-center gap-3 sm:gap-4">
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-amber-500/20 backdrop-blur-sm flex items-center justify-center text-2xl sm:text-3xl font-bold border-2 border-amber-500/30 shadow-lg shadow-amber-500/20">
                {trainer?.firstName?.charAt(0)}{trainer?.lastName?.charAt(0)}
              </div>
              <div>
                <h2 className="text-lg sm:text-xl font-bold">
                  {trainer?.firstName} {trainer?.lastName}
                </h2>
                <p className="text-amber-300/90 text-sm sm:text-base">{trainer?.specName}</p>
              </div>
            </div>
          </div>

          <div className="p-4 sm:p-6 space-y-3 sm:space-y-4">
            <div>
              <p className="text-xs sm:text-sm text-slate-400 mb-1">ID сотрудника</p>
              <p className="text-white font-medium text-sm sm:text-base">{trainer?.employeeId || trainer?.id}</p>
            </div>

            <div>
              <p className="text-xs sm:text-sm text-slate-400 mb-1">Телефон</p>
              <p className="text-white font-medium text-sm sm:text-base">{trainer?.phone}</p>
            </div>

            <div>
              <p className="text-xs sm:text-sm text-slate-400 mb-1">Отдел</p>
              <p className="text-white font-medium text-sm sm:text-base">{trainer?.department?.dep_name || 'Не указан'}</p>
            </div>

            {trainer?.middleName && (
              <div>
                <p className="text-xs sm:text-sm text-slate-400 mb-1">Отчество</p>
                <p className="text-white font-medium text-sm sm:text-base">{trainer?.middleName}</p>
              </div>
            )}
          </div>
        </div>

        {/* Услуги */}
        {trainer?.services && trainer.services.length > 0 && (
          <div className="bg-slate-800/40 backdrop-blur-xl rounded-xl sm:rounded-2xl shadow-lg p-4 sm:p-6 border border-slate-700/50">
            <h3 className="text-base sm:text-lg font-bold text-white/90 mb-3 sm:mb-4">Мои услуги</h3>
            <div className="space-y-2 sm:space-y-3">
              {trainer.services.map((service) => (
                <div
                  key={service.id}
                  className="flex items-center justify-between p-3 sm:p-4 bg-slate-700/30 rounded-xl border border-slate-600/30 hover:border-amber-500/30 transition-all"
                >
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-white text-sm sm:text-base truncate">{service.name}</p>
                    <p className="text-xs sm:text-sm text-slate-400">{service.duration} минут</p>
                  </div>
                  <p className="font-bold text-amber-400 ml-3 text-sm sm:text-base">{service.price}₽</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Выход */}
        <button
          onClick={handleLogout}
          className="w-full bg-gradient-to-r from-red-500 to-red-600 text-white py-3 sm:py-4 rounded-xl sm:rounded-2xl font-medium hover:from-red-600 hover:to-red-700 transition-all shadow-lg shadow-red-500/20 border border-red-500/30"
        >
          Выйти из аккаунта
        </button>
      </div>
  );
}
